module.exports = __webpack_public_path__ + "img/pq-grupo-mobile.cebd6e5a.svg";